import { CONSOLE_PATHS, consoleRoutes } from "@sagot/constants";
import { lazy, Suspense, type ReactNode } from "react";
import type { RouteObject } from "react-router";
import type { ConsoleRouteHandle } from "../../../../shell/console-layout";
import { PageSkeleton } from "./shared/states";

const ConnectorsPage = lazy(() => import("./list/connectors-page").then((module) => ({ default: module.ConnectorsPage })));
const ConnectorPage = lazy(() => import("./detail/connector-page").then((module) => ({ default: module.ConnectorPage })));
const OperationPage = lazy(() => import("./operation/operation-page").then((module) => ({ default: module.OperationPage })));
const ImportPage = lazy(() => import("./import/import-page").then((module) => ({ default: module.ImportPage })));

/** The crumb trail: workspace > Settings > Connectors (the Roles page uses the same handle shape). */
const HANDLE: ConsoleRouteHandle = { titleKey: "service.connectors.title", parent: { labelKey: "nav.settings", to: consoleRoutes.settings } };

function Lazy({ children }: { children: ReactNode }) {
  return <Suspense fallback={<PageSkeleton />}>{children}</Suspense>;
}

/**
 * Settings -> Connectors (SD-SC-17). These sit beside `settings/:panel?` the way `settings/roles` does: the more specific
 * address wins, each page guards itself (permission `connectors.view`, then the plan) and is lazy so the console's first load is unchanged.
 */
export const connectorRoutes: RouteObject[] = [
  { path: CONSOLE_PATHS.connectors, handle: HANDLE, element: <Lazy><ConnectorsPage /></Lazy> },
  { path: CONSOLE_PATHS.connectorImport, handle: HANDLE, element: <Lazy><ImportPage /></Lazy> },
  { path: CONSOLE_PATHS.connectorOperation, handle: HANDLE, element: <Lazy><OperationPage /></Lazy> },
  { path: CONSOLE_PATHS.connector, handle: HANDLE, element: <Lazy><ConnectorPage /></Lazy> },
];
